import { http } from '../../../../api/http';
import type { GuiaEntrada } from '../types/guiaEntrada.types';

export const guiaEntradaService = {
  async getAll(): Promise<GuiaEntrada[]> {
    const response = await http.get('/inventario/guia-entrada');
    return response.data;
  },

  async getById(id: number): Promise<GuiaEntrada> {
    const response = await http.get(`/inventario/guia-entrada/${id}`);
    return response.data;
  },

  async save(guia: Partial<GuiaEntrada>): Promise<GuiaEntrada> {
    const response = await http.post('/inventario/guia-entrada', guia);
    return response.data;
  },

  async delete(id: number): Promise<void> {
    await http.delete(`/inventario/guia-entrada/${id}`);
  },
};
